export const GOOGLE_AUTH_START = 'GOOGLE_AUTH_START'
export const GOOGLE_AUTH_SUCCESS = 'GOOGLE_AUTH_SUCCESS'
export const GOOGLE_AUTH_FAILED = 'GOOGLE_AUTH_FAILED'

export const SAVE_EMAIL_IN_REDUX = 'SAVE_EMAIL_IN_REDUX'

export const GOOGLE_PAGINATION_START = 'GOOGLE_PAGINATION_START'
export const GOOGLE_PAGINATION_SUCCESS = 'GOOGLE_PAGINATION_SUCCESS'
export const GOOGLE_PAGINATION_FAILED = 'GOOGLE_PAGINATION_FAILED'

export const GOOGLE_PAGE_TOKEN = 'GOOGLE_PAGE_TOKEN'
export const MICROSOFT_PAGE_LINK = 'MICROSOFT_PAGE_LINK'
